module.exports = __webpack_public_path__ + "static/img/RK464-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RK464-G_1.png
// module id = AkyH
// module chunks = 0